/**
 * Constants for Jobs feature
 * Centralized magic numbers and configuration values
 */
import type { JobResource } from "@/shared/types/job.types";
import type { JobStatusCode } from "../types/jobs.types";

// Pagination
export const JOBS_PAGE_SIZE = 20;
export const ACTIVE_JOBS_SEED_LIMIT = 100;

// File upload limits
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

// Timeout delays (in milliseconds)
export const PUSHER_RECONNECT_DELAY = 100;
export const JOB_REFRESH_DELAY = 1000;
export const NOTIFICATION_DELAY = 100;
export const MODAL_CLOSE_ANIMATION_DELAY = 300;

// Channel name base
export const BASE_JOBS_CHANNEL_NAME = "jobs_channel_";

// Job resources that drive post-success navigation / handling in JobModalButtons
export const JOB_RESOURCE = {
  VOUCHER_ATTRIBUTION: "ATTRIBUTION TITRES CADEAUX",
  ORDER_CREATION: "CREATION BON DE COMMANDE",
  CARD_REISSUANCE_BATCH: "CARD REISSUANCE BATCH",
  VOUCHER_INVOICES_EXPORT: "VOUCHER INVOICES EXPORT",
  NET_BALANCE_STATEMENT: "NET BALANCE STATEMENT",
  EMPLOYEE_IMPORT: "UPLOAD FICHIER",
} as const satisfies Record<string, JobResource>;

// Status colors for job status badges
export type StatusColors = Record<JobStatusCode, string> & { default: string };

export const STATUS_COLORS: StatusColors = {
  pending: "bg-yellow-100 text-yellow-800",
  starting: "bg-yellow-100 text-yellow-800",
  in_progress: "bg-yellow-100 text-yellow-800",
  cancelling: "bg-gray-100 text-gray-800",
  cancelled: "bg-gray-100 text-gray-800",
  processed: "bg-green-100 text-green-800",
  to_verify: "bg-orange-100 text-orange-800",
  failed: "bg-red-100 text-red-800",
  default: "bg-gray-100 text-gray-800",
};

// Mutation messages
export const JOB_MESSAGES = {
  CREATE_SUCCESS: "Tâche créée avec succès",
  CREATE_ERROR: "Erreur lors de la création de la tâche",
  CANCEL_SUCCESS: "Tâche annulée avec succès",
  CANCEL_ERROR: "Erreur lors de l'annulation de la tâche",
  CANCEL_IMPORT_PENDING: "Annulation de l'import en cours",
  VOUCHER_CREATE_SUCCESS: "Tâche de création de bons créée avec succès",
  VOUCHER_CREATE_ERROR: "Erreur lors de la création de la tâche de bons",
} as const;
